import src from "IMAGE";
export default { src, width: 48, height: 48, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALUlEQVR42rWOsQkAAAjD/P/K9o0uis4FFy0EOmRI5LK4EyQlgKG/FUgOVviLLKfG/VdND4cDAAAAAElFTkSuQmCC"};
